import React from "react";
import { Text, Pressable } from "react-native";
import { colors } from "../constants/colors";

export const BaseButton = ({
  text = "",
  onPress = () => {},
  containerStyle = {},
  textStyle = {},
  small = false,
  medium = false,
  ...props
}) => {
  return (
    <Pressable
      onPress={onPress}
      style={({ pressed }) => [
        {
          height: small ? 50 : medium ? 60 : 70,
          backgroundColor: colors.brightBlue,
          paddingHorizontal: 20,
          // width: "100%",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 15,
          opacity: pressed ? 0.8 : 1,
          shadowColor: colors.brightBlue,
          shadowOffset: {
            width: 0,
            height: 4,
          },
          shadowOpacity: 0.3,
          shadowRadius: 4.65,

          elevation: 8,
          marginBottom: 20,
        },
        containerStyle,
      ]}
      {...props}
    >
      <Text
        style={[
          {
            color: colors.darkGrey,
            fontSize: small ? 18 : medium ? 20 : 24,
            // textTransform: "uppercase",
            fontWeight: "600",
          },
          textStyle,
        ]}
      >
        {text}
      </Text>
    </Pressable>
  );
};
